import React, { useState } from 'react';
import { MapPinIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../offer-create/Urls';
import DataCard from '../profile-edit/DataCard';
import { PayloadStates } from '@lore/utils';
import useOfferTags from '../../hooks/useOfferTags';
import TagTypes from '../../constants/TagTypes';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function Location(props) {
  const { offer } = props;

  const { history } = usePageRouter();

  const [timestamp] = useState(new Date().toISOString());

  const offerInteractionTypes = useOfferTags(offer, TagTypes.InteractionType, timestamp);

  let subtitle = '';

  if (offerInteractionTypes.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = offerInteractionTypes.data.map(function(offerInteractionType) {
      return offerInteractionType.data.name;
    }).join(', ');
  }

  return (
    <DataCard
      title="Location"
      icon={MapPinIcon}
      subtitle={subtitle || '(not provided)'}
      onClick={() => history.push(Urls(offer).LOCATION)}
    />
  );
};
